enum DecisionMetricKeys {
  XG = "xg",
  XT = "xt",
  XP = "xp",
  XPT = "xpt",
}

export default DecisionMetricKeys;
